import { styled } from '@mui/material'

export const AutocompleteFieldWrapper:any  = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
`
